<div class="modal-header">
  <h4 class="modal-title fw-normal">Upload File</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
</div>

<div class="modal-body">
  <input #fileInput type="file" multiple class="d-none" (change)="onBrowseFiles($event)" />

  <section class="text-center">
    <div class="upload-dropzone mx-auto" [class.border-primary]="isDragOver()" [class.bg-light]="isDragOver()"
      (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)"
      (click)="fileInput.click()" tabindex="0" (keydown.enter)="fileInput.click()" (keydown.space)="fileInput.click()">
      <i class="bi bi-cloud-upload mb-3 h1"></i>
      <p class="fw-semibold mb-1">Drag & drop file here</p>
      <p class="text-muted mb-3">or</p>
      <button class="btn btn-outline-primary" type="button" (click)="$event.stopPropagation(); fileInput.click()">
        Browse Files
      </button>
    </div>

    @if (hasFiles()) {
    <div class="file-list-container mx-auto mt-3">
      @for (entry of files(); track entry.file.name + entry.file.lastModified) {
      <div class="file-list-item d-flex align-items-center border px-3 py-2 mb-2 bg-white rounded-3 gap-3 bg-light">
        <div class="file-item-left d-flex align-items-center gap-1 flex-grow-1">
          <div class="file-thumbnail d-flex align-items-center justify-content-center rounded-2">
            @if (entry.previewUrl) {
            <img [src]="entry.previewUrl" [alt]="entry.file.name" class="file-thumbnail-img" />
            } @else {
            <i class="fs-1" [ngClass]="[entry.badge?.iconClass, entry.badge?.textClass]"></i>
            }
          </div>
          <div class="flex-grow-1 text-truncate text-start">
            <p class="fw-semibold mb-0 small text-truncate">{{ entry.file.name }}</p>
          </div>
        </div>
        <button class="btn btn-close px-2 py-0 flex-shrink-0 ms-auto" type="button" (click)="removeFile(entry)"
          aria-label="Remove file"></button>
      </div>
      }
    </div>
    }
  </section>
</div>

<div class="modal-footer">
  <button class="btn btn-primary" type="button" (click)="onNext()" [disabled]="!hasFiles()">
    Next
  </button>
</div>
